import { SelectedCell } from "../../InvestmentMemo.types";

export const defaultColDef = (selectedCell?: SelectedCell, gridId?: string) => {
    return {
        cellStyle: (params: any) => {
            return {
                paddingLeft: (params.data?.indentLevel ?? 0) * 8 + "px",
            };
        },
        flex: 1,
        minWidth: 140,
        cellClass: (params) => {
            const isSelected =
                gridId === params.gridId &&
                selectedCell?.rowId === params.node.id &&
                selectedCell?.colField === params.colDef.field;
            return params.colDef.field !== "label"
                ? `cursor-pointer hover:bg-hover ${isSelected ? "bg-selected" : ""}`
                : "";
        },
    };
};
